import {Amplify} from 'aws-amplify';
import {generateClient} from 'aws-amplify/api';

if (!process.env.PROMPT_BRIDGE_APPSYNC_URL || !process.env.PROMPT_BRIDGE_APPSYNC_API_KEY) {
  throw new Error('PROMPT_BRIDGE_APPSYNC_URL or PROMPT_BRIDGE_APPSYNC_API_KEY is not set');
} else {
  Amplify.configure({
    API: {
      GraphQL: {
        defaultAuthMode: 'apiKey',
        region: 'eu-west-1',
        apiKey: process.env.PROMPT_BRIDGE_APPSYNC_API_KEY,
        endpoint: process.env.PROMPT_BRIDGE_APPSYNC_URL,
      },
    },
  });
}

export const promptBridgeAppSync = generateClient();
